import React from 'react';
import { CheckboxInput } from '@nearst/ui';

import styles from './ChannelSelection.module.scss';

const ChannelSelection = ({ channels, selectedChannels, onSelectionChange, mode, onModeChange, operation }) => {
	const handleChannelToggle = (channelId) => {
		const updated = { ...selectedChannels };
		updated[channelId] = !updated[channelId];
		onSelectionChange(updated);
	};

	const actionLabel = operation.type === 'hide' ? 'Hide from' : 'Unhide on';

	return (
		<div className={styles.channelSelection}>
			<fieldset className={styles.modeFieldset}>
				<legend className={styles.legend}>Channels</legend>
				<label className={styles.radioLabel}>
					<input
						type="radio"
						name="channel-mode"
						value="all"
						checked={mode === 'all'}
						onChange={() => onModeChange('all')}
					/>
					{actionLabel} all channels
				</label>
				<label className={styles.radioLabel}>
					<input
						type="radio"
						name="channel-mode"
						value="selected"
						checked={mode === 'selected'}
						onChange={() => onModeChange('selected')}
					/>
					{actionLabel} selected channels
				</label>
			</fieldset>

			{mode === 'selected' && (
				<div className={styles.channelList}>
					{channels.map((channel) => (
						<CheckboxInput
							key={channel.id}
							label={channel.label}
							checked={!!selectedChannels[channel.id]}
							onChange={() => handleChannelToggle(channel.id)}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export { ChannelSelection };
